import { first } from 'lodash';
import {
  ViewTemplateLayoutVideo,
  getLayoutMediaFiles,
} from '@shared/scenes/workflows/viewTemplateLayoutItems';
import styles from './layoutItems.module.css';

/**
 * The video of a video layout item, as a player.
 *
 * `preload="metadata"` rather than `auto`: a form can hold several of these and none of them is
 * why the form was opened, so each costs its dimensions and a poster frame until someone presses
 * play. The still the builder captured at upload stands in until then, so the slot is the right
 * shape before the browser has fetched anything of the video itself.
 */
export function LayoutVideoItem({ item }: { item: ViewTemplateLayoutVideo }) {
  const video = first(getLayoutMediaFiles(item));

  if (!video) {
    return null;
  }

  return (
    <div className={styles.item}>
      <video
        src={video.url}
        poster={video.posterUrl}
        controls
        playsInline
        preload="metadata"
        className={styles.video}
      />
    </div>
  );
}
